import React from 'react';
import type SoftwareCodeType from '@atlassian/jira-spa-apps-software-code/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { getBoardId } from './common/index.tsx';

/** @deprecated delete when cleaning up entrypoint_migration_for_software_code */
export const LazyCode = lazyForPaint<typeof SoftwareCodeType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-code-simplified", jiraSpaEntry:  "async-code-simplified" */ '@atlassian/jira-spa-apps-software-code/src/ui/index-old.tsx'
		),
	),
);

/** @deprecated delete when cleaning up entrypoint_migration_for_software_code */
export const CodePageClassic = ({ location, match }: RouteContext) => (
	<LazyPage
		Page={LazyCode}
		pageId={`classic-code-${getBoardId({ location, match })}`}
		shouldShowSpinner={false}
	/>
);
